import {RouteProps} from './utils/types';

export const routes: RouteProps = t => [
	{
		path: '/',
		label: 'Home',
		pagePath: '/Home',
		navBar: true
	},
	{
		path: '/about-us',
		label: 'About us',
		pagePath: '/AboutUs',
		navBar: true
	},
	{
		path: '/contact-us',
		label: 'Contact us',
		pagePath: '/ContactUs',
		navBar: false
	},
	{
		path: '/companies',
		label: 'Companies',
		pagePath: '/Companies',
		navBar: true
	},
	// {
	// 	path: '/team',
	// 	label: 'Team',
	// 	pagePath: '/Team',
	// 	navBar: true
	// },

	{
		path: '/services',
		label: 'Services',
		pagePath: '/Services',
		navBar: true
	},
	{
		path: '/partners',
		label: 'Partners',
		pagePath: '/Partners',
		navBar: true
	},

	{
		path: '/privacy-policy',
		label: 'Privacy Policy',
		pagePath: '/PrivacyPolicy',
		navBar: false
	}
];
